"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.read = exports.write = void 0;
var diveTileData_sidecar_1 = require("@dive/tilemap/diveTileData-sidecar");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var diveTilemapPart_sidecar_1 = require("@dive/tilemap/diveTilemapPart-sidecar");
var diveStringSaver_sidecar_1 = require("./diveStringSaver-sidecar");
var version = 'v0.1.1';
var namespace = 'tilemap';
function write() {
    diveStringSaver_sidecar_1.diveStringSaver.wHeader(namespace, version);
    var obj = diveTilemap_sidecar_1.diveTilemap.get();
    diveStringSaver_sidecar_1.diveStringSaver.wString('size');
    diveStringSaver_sidecar_1.diveStringSaver.wInt(obj.width);
    diveStringSaver_sidecar_1.diveStringSaver.wInt(obj.height);
    diveStringSaver_sidecar_1.diveStringSaver.wString('tiles');
    // TODO: index of tiles?
    for (var j = 0; j < obj.height; j++) {
        for (var i = 0; i < obj.width; i++) {
            var c = diveTilemap_sidecar_1.diveTilemap.getUnsafe(i, j);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.tile1.type);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.variant);
            diveStringSaver_sidecar_1.diveStringSaver.wInt(c.shadow);
        }
    }
    diveStringSaver_sidecar_1.diveStringSaver.wEnd(namespace);
}
exports.write = write;
function read() {
    diveStringSaver_sidecar_1.diveStringSaver.rHeader(namespace, version);
    diveStringSaver_sidecar_1.diveStringSaver.rString('size');
    var width = diveStringSaver_sidecar_1.diveStringSaver.rInt();
    var height = diveStringSaver_sidecar_1.diveStringSaver.rInt();
    diveStringSaver_sidecar_1.diveStringSaver.rString('tiles');
    diveTilemap_sidecar_1.diveTilemap.clear();
    for (var j = 0; j < height; j++) {
        for (var i = 0; i < width; i++) {
            var c = diveTilemap_sidecar_1.diveTilemap.getUnsafe(i, j);
            var type = diveStringSaver_sidecar_1.diveStringSaver.rInt();
            if (Number.isNaN(type)) {
                console.error('NaN tile', i, j, type);
            }
            diveTilemapPart_sidecar_1.diveTilemapPart.setTile(c, diveTileData_sidecar_1.diveTileData.get(type));
            c.variant = diveStringSaver_sidecar_1.diveStringSaver.rInt();
            c.shadow = diveStringSaver_sidecar_1.diveStringSaver.rInt();
        }
    }
    diveStringSaver_sidecar_1.diveStringSaver.rEnd(namespace);
}
exports.read = read;
